import { PlayerManagerProps as Props } from '../../../../../shared/types/props/player';
import { PlayerState } from '../../../../../shared/types/enums/player';
import { mediaSelector } from '../../../../../shared/store/slices/media.slice';
import { useAppSelector } from '../../../../../shared/store/hooks';
import { useEffect } from 'react';

const MILLISECONDS_TO_SECONDS = 1000;

export default function MediaManager({ shaka: player, video }: Props) {
  const { position, state } = useAppSelector(mediaSelector);

  useEffect(() => {
    if (video) {
      switch (state) {
        case PlayerState.PAUSE:
          try {
            video.pause();
          } catch (error) {
            console.error('[Shaka][Media manager] Pause');
          }
          break;

        case PlayerState.PLAY:
        case PlayerState.SEEKING:
          try {
            video.play();
          } catch (error) {
            console.error('[Shaka][Media manager] Play');
          }
          break;

        case PlayerState.SEEK:
          try {
            if (player?.isLive()) {
              const livePosition =
                player.seekRange().end -
                Math.abs((position - Date.now()) / MILLISECONDS_TO_SECONDS);
              video.currentTime = livePosition;
            } else {
              video.currentTime = position;
            }
          } catch (error) {
            console.error('[Shaka][Media manager] Seek');
          }
          break;

        default:
          break;
      }
    }
  }, [player, position, state, video]);

  return null;
}
